import styled from "styled-components";
import { Flex, Box } from "@edricphan2022/uikit";
import mediaQueries from "../../@uikit/theme/base";

export const Wrapper = styled(Box)`
  width: 100%;
  position: relative;
  background: linear-gradient(180deg, #fffef6 0%, rgba(251, 251, 243, 0) 100%);
`;

export const HowWorksStyle = styled(Box)`
  width: 100%;
  height: 100%;
  background: #fefbef;
  padding-top: 90px;
  background-image: url("/assets/about/BannerAbout.svg");
  background-position: center;
  height: 740px;
  padding-bottom: 100px;

  ${mediaQueries.mediaQueries.lg} {
    height: 90vh;
  }

  ${mediaQueries.mediaQueries.sm} {
    height: 150vh;
  }
`;

export const BoxInTouch = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 84px;
  padding-bottom: 30px;

  .cus-intouch-orbit {
    align-items: flex-start !important;

    & > * {
      width: 50%;
      position: relative;
    }
    & > *:nth-child(2) {
      min-height: 480px;
    }
  }

  .cus-gif {
    width: 250px;
  }

  ${mediaQueries.mediaQueries.sm} {
    .cus-intouch-orbit {
      flex-direction: column;

      & > * {
        width: 100%;
      }

      & > *:nth-child(2) {
        min-height: 420px;
      }
    }
  }
`;
